import { useRef, useState } from "react";
import { UploadCloud, Loader2, Play } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { SAMPLES } from "../lib/api";

export const Uploader = ({ loading, onFile, onUrl }) => {
  const ref = useRef();
  const [file, setFile] = useState(null);
  const [shown, setShown] = useState(null);
  const [label, setLabel] = useState("");
  const [drag, setDrag] = useState(false);
  const [rerank, setRerank] = useState(true);

  const pick = (f) => { if (f) { setFile(f); setShown(URL.createObjectURL(f)); } };

  return (
    <div className="grid md:grid-cols-12 gap-4">
      <div data-testid="moth-photo-dropzone" onClick={() => ref.current.click()}
        onDragOver={(e) => { e.preventDefault(); setDrag(true); }} onDragLeave={() => setDrag(false)}
        onDrop={(e) => { e.preventDefault(); setDrag(false); pick(e.dataTransfer.files[0]); }}
        className={`md:col-span-5 relative overflow-hidden aspect-[4/3] rounded border-2 border-dashed cursor-pointer grid place-items-center transition-colors ${drag ? "border-primary bg-primary/10" : "hover:border-primary/60"}`}>
        {shown ? <img src={shown} alt="specimen" className="absolute inset-0 w-full h-full object-cover" /> : (
          <div className="text-center text-muted-foreground px-4">
            <UploadCloud className="h-7 w-7 mx-auto mb-2 text-primary" />
            <div className="text-sm font-medium text-foreground">Drop a moth photo or click</div>
            <div className="text-xs font-mono">JPEG · PNG · WEBP ≤ 10MB</div>
          </div>
        )}
        {loading && <div className="absolute inset-0 bg-background/40"><div className="scanline" /></div>}
        <input ref={ref} data-testid="moth-photo-input" type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={(e) => pick(e.target.files[0])} />
      </div>
      <div className="md:col-span-7 space-y-3">
        <Input data-testid="true-label-input" className="font-mono text-sm" placeholder='true_label = "Genus species"  # optional' value={label} onChange={(e) => setLabel(e.target.value)} />
        <label className="flex items-center gap-2 text-xs font-mono cursor-pointer">
          <input data-testid="rerank-toggle" type="checkbox" checked={rerank} onChange={(e) => setRerank(e.target.checked)} className="accent-[hsl(var(--primary))]" />
          visual_rerank = {rerank ? "True" : "False"} <span className="text-muted-foreground"># compare with iNat reference photos (+~20 s)</span>
        </label>
        <Button data-testid="identify-submit-button" size="sm" disabled={!file || loading} onClick={() => onFile(file, label, rerank)}>
          {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Play className="h-4 w-4 mr-2" />}{loading ? "Running…" : "Run identification"}
        </Button>
        <div>
          <div className="text-xs font-mono text-muted-foreground mb-2"># reference specimens (iNaturalist, research grade)</div>
          <div className="grid grid-cols-4 sm:grid-cols-7 md:grid-cols-4 lg:grid-cols-7 gap-2">
            {SAMPLES.map((s, i) => (
              <button key={s.url} data-testid={`sample-specimen-btn-${i + 1}`} disabled={loading} title={`${s.caption} (${s.label})`}
                onClick={() => { setFile(null); setShown(s.url); onUrl(s.url, s.label, rerank); }}
                className="group relative aspect-square rounded overflow-hidden border hover:border-primary transition-colors disabled:opacity-50">
                <img src={s.url} alt={s.caption} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
